import { useQuery } from '@tanstack/react-query';
import { apiUrl, mockAuthHeaders } from '../lib/api';

interface BOMSearchResult {
  id: string;
  partNumber: string;
  description: string;
}

async function searchBoms(searchTerm: string): Promise<BOMSearchResult[]> {
  if (!searchTerm || searchTerm.length < 2) return [];

  const response = await fetch(
    apiUrl(`/api/v1/boms?partNumber=${encodeURIComponent(searchTerm)}&currentOnly=true&limit=10`),
    {
      headers: {
        'Content-Type': 'application/json',
        ...mockAuthHeaders(),
      },
      credentials: 'include',
    }
  );

  if (!response.ok) {
    throw new Error('Failed to search BOMs');
  }

  const json = (await response.json()) as { data: BOMSearchResult[] };
  return json.data ?? [];
}

export function useBomSearch(searchTerm: string, enabled = true) {
  return useQuery({
    queryKey: ['boms', 'search', searchTerm],
    queryFn: () => searchBoms(searchTerm),
    enabled: enabled && searchTerm.length >= 2,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
